import { render, staticRenderFns } from "./MdopList.vue?vue&type=template&id=40055e54&scoped=true&"
import script from "./MdopList.vue?vue&type=script&lang=js&"
export * from "./MdopList.vue?vue&type=script&lang=js&"
import style0 from "./MdopList.vue?vue&type=style&index=0&id=40055e54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40055e54",
  null
  
)

export default component.exports